import { IRootState } from '../../../store'
import { ICardiacOptionsState } from '../store/options.types'

export const getCardiacOptionsSelector = (state: IRootState): ICardiacOptionsState => state.options.cardiacOptions
